var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { staticClass: "subsystem-summary" },
    [
      _c(
        "td",
        {
          staticClass: "name-column",
          class: _vm.weight_summary_class,
          attrs: { colspan: "2" }
        },
        [
          _vm._v(
            _vm._s(_vm.se_subsystem.weight_internal.toFixed(2)) +
              "/" +
              _vm._s(_vm.se_subsystem.weight_cap.toFixed(2))
          )
        ]
      ),
      _vm._v(" "),
      _c("td", { staticClass: "part-column" }),
      _vm._v(" "),
      _vm._l(_vm.stats.names, function(name) {
        return [
          _c("StatlineCell", {
            key: name,
            attrs: { stats: _vm.stats, name: name }
          })
        ]
      }),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "weight-internal-column",
          class: _vm.weight_summary_class
        },
        [_vm._v(_vm._s(_vm.se_subsystem.weight_internal.toFixed(2)))]
      ),
      _vm._v(" "),
      _c("td", { staticClass: "weight-external-column" }, [
        _vm._v(_vm._s(_vm.se_subsystem.weight_external.toFixed(2)))
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "br-column" }, [
        _vm._v(_vm._s(_vm.se_subsystem.cost_BR.toFixed(2)))
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "sr-column" }, [
        _vm._v(_vm._s(_vm.se_subsystem.cost_SR.toFixed(2)))
      ]),
      _vm._v(" "),
      _vm.se_subsystem.refit_valid
        ? [
            _c("td", { staticClass: "br-column" }, [
              _vm._v(_vm._s(_vm.se_subsystem.refit_cost_BR.toFixed(2)))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "sr-column" }, [
              _vm._v(_vm._s(_vm.se_subsystem.refit_cost_SR.toFixed(2)))
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("td", { staticClass: "power-cost-column" }, [
        _vm._v(_vm._s(_vm.se_subsystem.cost_power.toFixed(2)))
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "power-gen-column" }, [
        _vm._v(_vm._s(_vm.se_subsystem.power_generation.toFixed(2)))
      ]),
      _vm._v(" "),
      _vm._l(_vm.crew.names, function(name) {
        return [
          _c("StatlineCell", {
            key: name,
            attrs: { stats: _vm.crew, name: name }
          })
        ]
      }),
      _vm._v(" "),
      _c("td", { staticClass: "build-time-column" }, [
        _vm._v(_vm._s(_vm.build_time))
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "tech-year-column" }, [
        _vm._v(_vm._s(_vm.tech_year))
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6beebb70", { render: render, staticRenderFns: staticRenderFns })
  }
}